﻿import { serviceTaskOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { rangeFilterUTC } from "../helpers/utils";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("service-tasks"),
  endpoint: "service-task",
  operations: serviceTaskOps,
  roleView: [ROLE.SC_TASK_VIEW, ROLE.SC_TASK_ADMIN],
  roleAdmin: [ROLE.SC_TASK_ADMIN],
  baseRoute: "service-tasks",
  singularName: (t) => t("Service task"),
  name: (t) => t("Service tasks"),

  sendCulture: true,
  initialFilter: {
    sortBy: "reportedOn",
    sortOrder: "descend",
  },
  filterFormatter: rangeFilterUTC,
  syncCustomerFilter: true,
  dependencies: ["app-message"],
});

export default conf;
